import { hmlInitAttr}from '@/store/modules/initialAttributes'
import { loadModules } from 'esri-loader';
import clonedeep from 'lodash.clonedeep';

function featureLayerApplyEdits(attrs) {

  return loadModules(["esri/layers/FeatureLayer", "esri/Graphic"]).then(([FeatureLayer, Graphic]) => {


    const featureLayer = new FeatureLayer({
      url: process.env.__MAP_SERVER_URLS__.HML_NETWORK_FS,
      layerId: 0
    });

    var j = {
    //   "geometry": attrs._geometry,
      "attributes": attrs
    } 
    var g = Graphic.fromJSON(j)
    console.log("Editing Object",j);
    return featureLayer.load().then(function (f) {
      console.log(f)

      //if have OBJECTID, update feature, else add feature
      if (g.attributes.OBJECTID) {
        return f.applyEdits({
          updateFeatures: [g]
        })
      } else {
        return f.applyEdits({
          addFeatures: [g]
        })
      }

    }).otherwise(function (err) {
      console.log("there was an error: ", err);
      return err;
    });
  });
}


const state = {
    attributes: hmlInitAttr
}
// getters
const getters = {

}
const actions = {
    updateAttributes({ state, commit }, newAttributeObj){
        commit('updateAttributes',newAttributeObj)
    },
    clearState({state,commit}){
        commit('clearState', {
          attributes: hmlInitAttr
        })
    },
    applyEdit({ state, commit }){
      //state would store all attributes including the _geometry
      return featureLayerApplyEdits(state.attributes);
    },
}
const mutations = {
    updateAttributes(state, newAttributeObj) {
      state.attributes = newAttributeObj;
    },
    clearState(state, newState) {
      Object.assign(state, newState)
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/hml.js